/**
 * SINGLE SOURCE OF TRUTH FOR ALL PROJECTS
 * Add new projects here - all other files will auto-update
 */

export const PROJECTS_CONFIG = [
    {
        id: "PRC",
        name: "$PRICE",
        shortName: "$PRICE",
        imageSrc: "/assets/price.png",
        contracts: {
            preSale: "0xA2B4b493ac1BE5c34f6d482D4816615dA711B902",
            claim: "0x35958203b07414166dC0637F3bDd1FC2A0f00a54",
        },
        graph: {
            url: "https://api.goldsky.com/api/public/project_cmgziwe33001x5np2h4zd6mkb/subgraphs/xen-graph/0.0.1/gn",
            queryType: "standard",
        },
        contractType: "screx", // Which contract helper to use
        refLink: 'https://buy.xen.trade/?leader=',
        enabled: true
    },
];
// Global tokens (not project-specific)
export const GLOBAL_TOKENS = {
    eth: "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE",
    busd: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9", // USDT
    usdc: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    
    tomi: "0x84f0bC91f23649c76139d402a1c00c6aC19A4400",
   
    
    wbtc: "0x54410d42628C7fD6720C489219033345Bcb7Cc73",
    gems: "0x7ddd14e3a173a5db7bb8fd74b82b667f221492b9",
    pepe: "0x0592EBa69Aa5f2eF68d9cb740fBaB2c0c0CC6A91",
    link: "0x37bBd68526C9BDb49f18fB36983701E344f2A163",
    uni: "0x079c46A5Ba477400a326E03Ad8D22FaBeaE57b4F",
    dop: "0xa048E46C35cf210bB0d5bb46b2DD06828Ef17893",
};

// Legacy contracts (if needed)
export const LEGACY_CONTRACTS = {
    CreateDopRound: "0x2D4e8121AeE68679054018037832947a3E0Bcf8A",
    CreateNFTRound: "0x1119c2d708E42Fb591FCe77283b0791a135855ba",
    CreateDopTomiRound: "0xf4Fa4f08811Ea1F79a809129192279d97D88EF51",
    CreateNFTTomiRound: "0xCFd7cB1528f32aDFFC40D2A7199E80799E4E4736",
    InstitutionPreSale: "0x2E1858809393FaDb72D406Bb4E4699AD759e88fa",
};